import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../lib/api';

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);

  // Only accept a real settings object; a misconfigured backend can return an
  // HTML string (SPA fallback) which must not become `settings`.
  const isObj = (v) => v && typeof v === 'object' && !Array.isArray(v);
  const refresh = () => api.get('/settings').then((r) => { if (isObj(r.data)) setSettings(r.data); }).catch(() => {});
  useEffect(() => { refresh(); }, []);

  return <SiteContext.Provider value={{ settings, refresh }}>{children}</SiteContext.Provider>;
}

export function useSite() {
  return useContext(SiteContext) || { settings: null, refresh: () => {} };
}
